import { DIAL_TARGET_CALL_BACK, DIAL_TARGET_CONTACT, DIAL_TARGET_CONTACT_PHONE, DIAL_TARGETS_BY_ID } from 'src/constants/dial-targets'
import { isMaskedPhoneNumber } from 'src/plugins/helpers/phone-masking'

export const contactDialTarget = (contactId) => `${DIAL_TARGET_CONTACT}${contactId}`

export const contactPhoneDialTarget = (contactPhoneNumberId) => `${DIAL_TARGET_CONTACT_PHONE}${contactPhoneNumberId}`

export const callBackDialTarget = (communicationId) => `${DIAL_TARGET_CALL_BACK}${communicationId}`

/**
 * Call back a communication by its id only when its number is masked: a two-legged call cannot take
 * the id, so a number the user can read is dialed as it is.
 * @param {Object} communication
 * @returns {string|null}
 */
export const callBackDialTargetFor = (communication) => isMaskedPhoneNumber(communication.lead_number) ? callBackDialTarget(communication.id) : null

export const isDialTargetById = (value) => typeof value === 'string' && DIAL_TARGETS_BY_ID.some(prefix => value.startsWith(prefix))

/**
 * @param {string|null} target
 * @returns {number|null} the contact phone number id the target names, if any
 */
export const contactPhoneNumberIdOf = (target) => {
  if (typeof target !== 'string' || !target.startsWith(DIAL_TARGET_CONTACT_PHONE)) {
    return null
  }

  return parseInt(target.slice(DIAL_TARGET_CONTACT_PHONE.length))
}

/**
 * The recipient of a text to a contact: one of its numbers by id, or none for its primary
 * number, which the API defaults to.
 * @param {number|null} contactPhoneNumberId
 * @returns {Object}
 */
export const contactTextRecipient = (contactPhoneNumberId) => contactPhoneNumberId ? { contact_phone_number_id: contactPhoneNumberId } : {}

/**
 * The make-two-legged-call payload for a dial target: the contact's primary number is the
 * endpoint's default, and one of its numbers goes by id.
 * @param {string} target
 * @returns {Object|null} null when the target does not name a contact's number
 */
export const twoLeggedCallPayload = (target) => {
  if (typeof target === 'string' && target.startsWith(DIAL_TARGET_CONTACT)) {
    return {}
  }

  const contactPhoneNumberId = contactPhoneNumberIdOf(target)

  return contactPhoneNumberId ? { contact_phone_number_id: contactPhoneNumberId } : null
}
